<template>

  <Menu active-name="" theme="light" width="auto"  :open-names="['1','2', '3', '4']">
      <Submenu name="1">
      <template #title>
          <Icon type="ios-navigate"></Icon>
          内容管理
      </template>
      <MenuItem name="1-1" :to="{path: '/admin/article/all',}">内容列表</MenuItem>
      <MenuItem name="1-2" :to="{path: '/admin/article/add',}">内容发布</MenuItem>
      </Submenu>
      <Submenu name="2">
      <template #title>
          <Icon type="ios-keypad"></Icon>
          维权咨询管理
      </template>
      <MenuItem name="2-1" :to="{path: '/admin/question/all'}">问题审核</MenuItem>
      <MenuItem name="2-2" :to="{path: '/admin/answer/all'}">回答审核</MenuItem>
      </Submenu>
      <Submenu name="3">
      <template #title>
          <Icon type="ios-analytics"></Icon>
          投诉举报
      </template>
      <MenuItem name="3-1" :to="{path: '/admin/complaint/apply/all'}">举报处理</MenuItem>
      </Submenu>
      <Submenu name="4">
      <template #title>
          <Icon type="ios-analytics"></Icon>
          在线机器人维权
      </template>
      <MenuItem name="4-1" :to="{path: '/admin/keyword/all'}">关键词管理</MenuItem>
      <MenuItem name="4-2" :to="{path: '/admin/keyword/add'}">创建关键词</MenuItem>
      </Submenu>
  </Menu>

</template>
